import React from "react";
import { Modal, DatePicker, message, Radio } from "antd";
import API_URL from "../../../common/url";
import ExportUtil from "../../../common/ExportUtil";
import moment from "moment";
import Fetch from "../../../common/Fetch";

const RadioGroup = Radio.Group;
const { MonthPicker } = DatePicker;
const RadioStyle = {
    lineHeight: "28px",
    display: "grid",
};
const RadioGroupStyle = {
    display: "block",
    height: 30,
    lineHeight: "30px",
};
const DefaultDate = moment().format('YYYY-MM');
const DefaultState = {
    range: 'total',
    date: DefaultDate,
    investigationId: undefined,
};

class ExportFixedLine extends React.Component {
    state = {
        visible: false,
        loading: false,
        ...DefaultState,
    }

    show = () => {
        this.setState({
            visible: true,
            ...DefaultState,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    confirm = () => {
        const { date, range, investigationId } = this.state;

        if (range === 'total' && investigationId === undefined) {
            message.warning('请选择固化数据导出方式！');
            return;
        }
        
        this.setState({ loading: true });
        Fetch.post(API_URL.investigation.checkDownloadUserFte, {
            investigationId,
            date,
        }).then(() => {
            this.setState({ loading: false }, () => {
                this.export();
            });
        }).catch(() => {
            this.setState({ loading: false });
        });
    }

    export = () => {
        const { date, investigationId } = this.state;
        const url = API_URL.investigation.downloadUserFte;
        ExportUtil.export({ date, investigationId }, null, url);
        this.hide();
    }

    handleChange = (value, key) => {
        const extra = {};
        if (key === 'range') {
            if (value === 'detail') {
                extra.investigationId = -4;
            } else {
                extra.investigationId = undefined;
            }
        }
        this.setState({
            [key]: value,
            ...extra,
        });
    }

    disabledDate = (current) => {
        return current && current.valueOf() > moment().valueOf();
    }

    render() {
        const { visible, loading, date, range, investigationId } = this.state;
        return (
            <Modal
                title="导出固化数据"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal"
                width="460px"
                loading={loading}
            >
                <div className="modal-content" style={{ padding: '0 20px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left">请先选择固化月份</div>
                            <div className="item-right">
                                <MonthPicker
                                    allowClear={false}
                                    placeholder="选择月份"
                                    style={{ width: 160 }}
                                    value={date ? moment(date) : null}
                                    disabledDate={this.disabledDate}
                                    onChange={(date, dateString) => this.handleChange(dateString, 'date')}
                                />
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left">导出数据范围</div>
                            <div className="item-right">
                                <RadioGroup
                                    style={RadioStyle}
                                    value={range}
                                    onChange={e => this.handleChange(e.target.value, 'range')}
                                >
                                    <Radio value='total' style={RadioGroupStyle}>完工百分比汇总数据</Radio>
                                    <Radio value='detail' style={RadioGroupStyle}>完工百分比明细数据</Radio>
                                </RadioGroup>
                            </div>
                        </li>
                        {
                            range === 'total' &&
                            <li className="modal-item">
                                <div className="item-left">固化数据导出方式</div>
                                <div className="item-right">
                                    <RadioGroup
                                        style={RadioStyle}
                                        value={investigationId}
                                        onChange={e => this.handleChange(e.target.value, 'investigationId')}
                                    >
                                        <Radio value={-2} style={RadioGroupStyle}>全部 (财务版)</Radio>
                                        <Radio value={0} style={RadioGroupStyle}>全部 (核对版)</Radio>
                                        <Radio value={-3} style={RadioGroupStyle}>排除暂停&终止 (财务版)</Radio>
                                        <Radio value={-1} style={RadioGroupStyle}>排除暂停&终止 (核对版)</Radio>
                                    </RadioGroup>
                                </div>
                            </li>
                        }
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default ExportFixedLine;



// WEBPACK FOOTER //
// ./src/components/sumTotal/proPercent/ExportFixedLine.js